import React from 'react';
import { Text, HStack } from 'native-base';
import IosCheckmarkCircle from 'react-ionicons/lib/IosCheckmarkCircle'
import IosClose from 'react-ionicons/lib/IosClose'

export default function DetailRow({icon, name, state}) {
    return (
        <HStack space="5" alignItems="left">
            <Text>{icon}</Text>
            <Text style={{width: "100px"}}>{name}</Text>
            <Text>{state ? <IosCheckmarkCircle color='green' /> : <IosClose color='red' />}</Text>
        </HStack>
    )
}